module.exports = __webpack_public_path__ + "img/tuto1.4fbd5032.png";